import {  BuyerSellerDumpReportReducerDispatch, BuyerSellerDumpReportReduxTypes, CreateBuyerSellerDumpReportReduxState } from "./types"

const BUYER_SELLER_DUMP_REPORT_INITIAL_STATE = {
    data: {},
    loading: false,
    error: null
}

const CreateBuyerSellerDumpReportReducer = (state: CreateBuyerSellerDumpReportReduxState = BUYER_SELLER_DUMP_REPORT_INITIAL_STATE, action: BuyerSellerDumpReportReducerDispatch) => {
    switch (action.type) {
        case BuyerSellerDumpReportReduxTypes.BUYER_SELLER_DUMP_REPORT:
            return {
                ...state,
                loading: true
            }
        case BuyerSellerDumpReportReduxTypes.BUYER_SELLER_DUMP_REPORT_SUCCESS:
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        case BuyerSellerDumpReportReduxTypes.BUYER_SELLER_DUMP_REPORT_ERROR:

            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        default:
            return { ...state }
    }
}

export { CreateBuyerSellerDumpReportReducer }